export * from './actions.service';
import { ActionsService } from './actions.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './avatar.service';
import { AvatarService } from './avatar.service';
export * from './constants.service';
import { ConstantsService } from './constants.service';
export * from './contactsupport.service';
import { ContactsupportService } from './contactsupport.service';
export * from './documents.service';
import { DocumentsService } from './documents.service';
export * from './foldermodes.service';
import { FoldermodesService } from './foldermodes.service';
export * from './folders.service';
import { FoldersService } from './folders.service';
export * from './invitation.service';
import { InvitationService } from './invitation.service';
export * from './organizations.service';
import { OrganizationsService } from './organizations.service';
export * from './predictions.service';
import { PredictionsService } from './predictions.service';
export * from './rules.service';
import { RulesService } from './rules.service';
export * from './rulesoffolder.service';
import { RulesoffolderService } from './rulesoffolder.service';
export * from './rulestatus.service';
import { RulestatusService } from './rulestatus.service';
export * from './statistics.service';
import { StatisticsService } from './statistics.service';
export * from './statuslines.service';
import { StatuslinesService } from './statuslines.service';
export * from './tags.service';
import { TagsService } from './tags.service';
export * from './uploadFromEmail.service';
import { UploadFromEmailService } from './uploadFromEmail.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './variables.service';
import { VariablesService } from './variables.service';
export const APIS = [
  ActionsService,
  AuthService,
  AvatarService,
  ConstantsService,
  ContactsupportService,
  DocumentsService,
  FoldermodesService,
  FoldersService,
  InvitationService,
  OrganizationsService,
  PredictionsService,
  RulesService,
  RulesoffolderService,
  RulestatusService,
  StatisticsService,
  StatuslinesService,
  TagsService,
  UploadFromEmailService,
  UserService,
  VariablesService,
];
